import { Routes } from '@angular/router';
import { roleGuard } from './shared/guards/auth.guard';

/**
 * Root routing.
 *
 * - oglasnik-v3 (javni leadgen za usluge) lives at root: /, /usluge, /u/:slug, /login, /about, /contact
 * - dashboard-v3 (interni recruiter dashboard) lives under /dashboard/*
 * - klijent (K3, osobni link bez prijave) lives under /k/* — prije '' da ga oglasnik ne proguta
 * - račun klijenta (K5, prijavljeni KUPAC → uloga 'klijent') lives under /racun/* — isto prije ''
 * - '**' hvata i stare job-board URL-ove (/poslovi, /jobs/:id, /apply, …) i vodi ih na '/'
 */
export const routes: Routes = [
  {
    path: 'k',
    loadChildren: () => import('./klijent/klijent.routes').then(m => m.KLIJENT_ROUTES),
  },
  {
    path: 'racun',
    canMatch: [roleGuard('klijent')],
    loadChildren: () => import('./klijent/racun/racun.routes').then(m => m.RACUN_ROUTES),
  },
  {
    path: '',
    loadChildren: () =>
      import('./oglasnik-v3/oglasnik-v3.routes').then(m => m.OGLASNIK_V3_ROUTES),
  },
  {
    path: 'dashboard',
    canMatch: [roleGuard('employer', 'admin', 'subadmin')],
    loadChildren: () =>
      import('./dashboard-v3/dashboard-v3.routes').then(m => m.DASHBOARD_V3_ROUTES),
  },
  { path: '**', redirectTo: '' },
];
